import {
  SET_OL_MAP,
  SET_CENTER,
  SET_BASE_MAP,
  ZOOM_IN,
  ZOOM_OUT,
  SET_ZOOM,
  SET_TILE_LOADING,
  SET_TILE_LOADED,
  SET_AREA_DRAWING,
  SET_AREA,
  CLEAR_AREA_DRAWING,
  SET_LEGEND_DATA,
  SET_TYPE,
  SET_DEFORMATION_RATE_INTERVAL_VALUE,
  SET_CHART_CONTAINER_OPEN,
  SET_BASE_MAP_LIST_VISIBLE,
  SET_INFO_BOX_OPEN,
  SET_MAP_LAYERS,
  SET_CHENGELOG_BOX_OPEN
} from '../actionTypes'

export const setOlMap = (olMap) => ({
  type: SET_OL_MAP,
  payload: olMap,
})

export const setInfoBoxOpen = (isOpen) => ({
  type: SET_INFO_BOX_OPEN,
  payload: isOpen,
})

export const setChangelogBoxOpen = (isOpen) => ({
  type: SET_CHENGELOG_BOX_OPEN,
  payload: isOpen,
})

export const setChartContainerOpen = (isOpen) => ({
  type: SET_CHART_CONTAINER_OPEN,
  payload: isOpen,
})

export const setMapLayers = (layers) => ({
  type: SET_MAP_LAYERS,
  payload: layers,
})


export const setBaseMapVisibly = (isOpen) => ({
  type: SET_BASE_MAP_LIST_VISIBLE,
  payload: isOpen,
})

export const setType = (type) => ({
  type: SET_TYPE,
  payload: type,
})

export const setDeformationRateIntervalValue = (value) => ({
  type: SET_DEFORMATION_RATE_INTERVAL_VALUE,
  payload: value,
})

export const setBaseMap = (baseMap) => ({
  type: SET_BASE_MAP,
  payload: baseMap,
})

export const setCenter = (center) => ({
  type: SET_CENTER,
  payload: center,
})

export const zoomIn = () => ({
  type: ZOOM_IN,
})

export const zoomOut = () => ({
  type: ZOOM_OUT,
})

export const setZoom = (zoom) => ({
  type: SET_ZOOM,
  payload: zoom,
})

export const setTileLoading = () => ({
  type: SET_TILE_LOADING,
})

export const setTileLoaded = () => ({
  type: SET_TILE_LOADED,
})

export const setAreaDrawing = (isAreaDrawingDisabled) => ({
  type: SET_AREA_DRAWING,
  payload: isAreaDrawingDisabled,
})

export const clearAreaDrawing = () => ({
  type: CLEAR_AREA_DRAWING,
})

export const setArea = (selectedArea) => ({
  type: SET_AREA,
  payload: selectedArea,
})

export const setLegendData = (data) => ({
  type: SET_LEGEND_DATA,
  payload: data,
})
